import { React, useEffect } from "react";
import { useLocation } from "react-router-dom";

function ScrollToTop() {
    const { pathname } = useLocation();

    useEffect(() => {
        document.body.scrollTop = 0;
        document.body.scrollTo?.(0, 0);
    }, [pathname]);

    return null;
}

export default ScrollToTop;